// Map icons, drawn on canvas at 2x and registered with the map on demand:
// event markers (a square plate with a glyph, by the event's icon and
// whether it is under way, over or still to come) and unit counters (NATO
// unit frames with size marks for land units, ship and aircraft
// silhouettes for naval and air units).
//
// The glyphs are SVG paths (512x512) from game-icons.net, CC BY 3.0
// (https://creativecommons.org/licenses/by/3.0/), by the authors named on
// each line. The map's attribution credits them.

const INK = "#0b0e14"; // outlines and glyphs on a colored plate
const LIGHT = "#dfe6f3"; // size marks above a counter
const PAST_FILL = "#151b27";

// prettier-ignore
const GLYPHS = {
  "crossed-swords": "M19.75 14.438c59.538 112.29 142.51 202.35 232.28 292.718l3.626 3.75.063-.062c21.827 21.93 44.04 43.923 66.405 66.25-18.856 14.813-38.974 28.2-59.938 40.312l28.532 28.53 68.717-68.717c42.337 27.636 76.286 63.646 104.094 105.81l28.064-28.06c-42.47-27.493-79.74-60.206-106.03-103.876l68.936-68.938-28.53-28.53c-11.115 21.853-24.413 42.015-39.47 60.593-43.852-43.8-86.462-85.842-130.125-125.47-.224-.203-.432-.422-.656-.625C183.624 122.75 108.515 63.91 19.75 14.437zm471.875 0c-83.038 46.28-154.122 100.78-221.97 161.156l22.814 21.562 56.81-56.812 13.22 13.187-56.438 56.44 24.594 23.186c61.802-66.92 117.6-136.92 160.97-218.72zm-329.53 125.906l200.56 200.53c-4.36 4.443-8.84 8.793-13.405 13.032L148.875 153.53l13.22-13.186zm-76.69 113.28l-28.5 28.532 68.907 68.906c-26.29 43.673-63.53 76.414-106 103.907l28.063 28.06c27.807-42.164 61.758-78.174 104.094-105.81l68.718 68.717 28.53-28.53c-20.962-12.113-41.08-25.5-59.937-40.313 17.865-17.83 35.61-35.433 53.157-52.97l-24.843-25.655-55.47 55.467c-4.565-4.238-9.014-8.62-13.374-13.062l55.844-55.844-24.53-25.374c-18.28 17.856-36.602 36.06-55.158 54.594-15.068-18.587-28.38-38.758-39.5-60.625z", // Lorc
  "explosion-rays": "M54.184 19.512l116.02 144.838c-11.806 9.74-21.4 22.066-27.923 36.095L20.493 142.73v62.993l113.983 19.172c-1.12 6.056-1.707 12.295-1.707 18.67 0 3.502.177 6.965.52 10.378l-72.376 27.7 79.467.687c4.165 10.173 9.917 19.534 16.948 27.775L20.492 441.7v52.484h47.336l105.87-168.65c11.644 8.795 25.212 15.165 39.945 18.366l-23.7 150.284H294.22L253.25 344.69c8.668-1.524 16.964-4.14 24.744-7.7l37.262 42.268-21.326-51.365c6.885-4.792 13.16-10.402 18.68-16.692l182.533 146.61V348.556L329.43 284.865c4.29-9.722 7.118-20.227 8.195-31.238l84.7-25.93-86.78-7.008c-2.26-9.89-5.955-19.242-10.852-27.825l170.452-87.398V23.924L311.918 175.15c-5.33-5.95-11.342-11.28-17.912-15.86l15.533-38.382-29.968 29.967c-9.608-4.595-20.034-7.74-30.996-9.148L269.89 19.512h-40.12l1.27 121.478c-19.017.808-36.716 6.816-51.706 16.64L94.102 19.51H54.184z", // Lorc
  "scroll-unfurled": "M103.432 17.844c-1.118.005-2.234.032-3.348.08-2.547.11-5.083.334-7.604.678-20.167 2.747-39.158 13.667-52.324 33.67-24.613 37.4 2.194 98.025 56.625 98.025.536 0 1.058-.012 1.583-.022v.704h60.565c-10.758 31.994-30.298 66.596-52.448 101.43-2.162 3.4-4.254 6.878-6.29 10.406l34.878 35.733-56.263 9.423c-32.728 85.966-27.42 182.074 48.277 182.074v-.002l9.31.066c23.83-.57 46.732-4.298 61.325-12.887 4.174-2.458 7.63-5.237 10.467-8.42h-32.446c-20.33 5.95-40.8-6.94-47.396-25.922-8.956-25.77 7.52-52.36 31.867-60.452 5.803-1.93 11.723-2.834 17.565-2.834v-.406h178.33c-.57-44.403 16.35-90.125 49.184-126 23.955-26.176 42.03-60.624 51.3-94.846l-41.225-24.932 38.272-6.906-43.37-25.807h-.005l.002-.002.002.002 52.127-8.85c-5.232-39.134-28.84-68.113-77.37-68.113C341.14 32.26 222.11 35.29 149.34 28.496c-14.888-6.763-30.547-10.723-45.908-10.652zm.464 18.703c13.137.043 27.407 3.804 41.247 10.63l.033-.07c4.667 4.735 8.542 9.737 11.68 14.985H82.92l10.574 14.78c10.608 14.83 19.803 31.99 21.09 42.024.643 5.017-.11 7.167-1.814 8.836-1.705 1.67-6.228 3.875-15.99 3.875-40.587 0-56.878-44.952-41.012-69.06C66.238 46.64 79.582 39.22 95.002 37.12c2.89-.395 5.863-.583 8.894-.573zM118.5 80.78h46.28c4.275 15.734 3.656 33.07-.544 51.51H131.52c1.9-5.027 2.268-10.574 1.6-15.77-1.527-11.913-7.405-24.065-14.62-35.74zm101.553 317.095c6.44 6.84 11.192 15.31 13.37 24.914 3.797 16.736 3.092 31.208-1.767 43.204-4.526 11.175-12.576 19.79-22.29 26h237.19c14.448 0 24.887-5.678 32.2-14.318 7.312-8.64 11.2-20.514 10.705-32.352-.186-4.473-.978-8.913-2.407-13.18l-69.91-8.205 42.017-20.528c-8.32-3.442-18.64-5.537-31.375-5.537H220.053zm-42.668.506c-1.152-.003-2.306.048-3.457.153-2.633.242-5.256.775-7.824 1.63-15.11 5.02-25.338 21.54-20.11 36.583 3.673 10.57 15.347 17.71 25.654 13.938l1.555-.57h43.354c.946-6.36.754-13.882-1.358-23.192-3.71-16.358-20.543-28.483-37.815-28.54z", // Lorc
  "fist": "M227.227 21.777c-1.845 0-3.704.05-5.567.157-15.314.875-30.76 5.305-39.494 10.863l-.008 73.15c2.884-.094 5.777-.147 8.676-.142 23.382.036 47.104 3.286 68.47 9.513l.01-87.507c-7.034-3.518-19.178-6.03-32.087-6.033zm80.74 9.16c-11.925.15-23.077 2.364-29.967 5.596l-.008 77.602v7.658c38.486 15.67 64.814 42.48 58.735 78.764l-.96 5.73-5.562 1.674c-17.45 5.253-34.872 9.703-52.225 13.335V246.53c25.562-.704 51.327-2.687 77.145-6.098l.02-197.928c-8.284-5.563-23.508-10.243-38.842-11.328-2.792-.198-5.584-.273-8.336-.238zM143.223 46.294c-1.176-.015-2.374-.01-3.588.02-4.175.1-8.533.468-12.903 1.152-15.67 2.454-31.477 8.565-40.406 15.402l-.01 72.955c18.808-15.81 46.704-25.143 77.15-28.54l.007-57.966c-4.82-1.752-12.018-2.916-20.25-3.023zm258.394 3.46c-10.804.117-20.722 1.93-27.043 4.655l-.02 183.182c25.074-4.02 50.16-9.412 75.122-16.358l1.99-158.447c-8.352-5.9-23.648-11.025-39.05-12.553-3.698-.366-7.398-.517-11-.478zm-222.775 74.202c-53.72.702-101.407 20.365-97.887 66.6 15.836-3.918 30.84-5.893 44.94-6.1 34.84-.51 64.213 9.704 87.318 27.613 34.608-3.11 69.852-10 105.412-20.314.14-41.287-74.098-68.657-139.783-67.8zm-48.877 78.65c-1.296-.003-2.603.012-3.92.045-17.256.436-36.45 4.03-57.566 11.037 5.79 53.808 26.325 106.41 58.5 143.346 6.226 7.15 12.856 13.712 19.875 19.615 29.303 9.282 69.26 12.917 110.534 12.14 3.777-55.805-8.717-108.357-36.193-142.74-21.265-26.61-51.064-43.39-91.232-43.444zm129.326 22.282c-9.358 1.637-18.69 3.016-27.995 4.15 1.54 1.74 3.043 3.52 4.502 5.346 3.146 3.937 6.094 8.062 8.873 12.334 9.916.144 19.868.125 29.857-.106H259.29v-21.723zm191.817 15.343c-65.406 17.826-131.462 25.41-195.85 25.315 16.998 35.144 23.828 78.093 21.013 122.6 42.482-2.08 85.03-8.23 118.187-15.983 26.693-32.78 47.37-77.118 56.65-131.932zM400.51 389.9c-38.334 9.145-87.95 16.056-136.873 17.454-47.67 1.36-94.336-2.228-129.448-15.262l-.01 78.93c27.187 12.568 76.414 20.205 127.318 20.298 51.224.094 104.214-7.173 139-20.773l.012-80.647z", // Lorc
  "plain-dagger": "M43.53 15.75c-15.73 0-28.31 12.583-28.31 28.313 0 14.086 10.092 25.644 23.5 27.906L42.687 68 68.81 41.906l2.626-2.625C69.188 25.86 57.63 15.75 43.53 15.75zm33.72 44.125l-17 17c15.885 39.37 43.45 66.684 78.75 87.406 8.167-8.585 16.65-16.898 25.438-24.936-22.488-35.103-51.535-62.294-87.188-79.47zM322.594 79.03l-51.25 4.314c-79.356 48.134-143.878 108.1-186.72 186.53l-4.31 51.47 44.155-18.656-2.94-34.094-.25-3.063 1.626-2.624c35.94-58.47 79.93-109.41 141.5-141.25l2.406-1.25 2.688.25 34.125 2.906 18.97-44.53zm-62.438 66.376c-10.008 5.886-19.5 12.338-28.562 19.313 46.688 47.93 87.208 108.588 114.72 166.5l11.248 23.717-23.718-11.28c-57.995-27.554-117.918-67.57-165.688-113.907-7.155 9.404-14.028 19.174-20.625 29.28 101.918 94.91 227.05 177.304 347.845 234.69-57.063-120.125-140.038-246.18-235.22-348.314zm-43.03 31.22c-13.37 11.703-25.72 24.58-37.282 38.436 39.36 38.452 88.085 72.83 136.687 98.844-26.054-48.633-60.754-97.847-99.405-137.28z", // Lorc
  "skull-crossed-bones": "M425.344 22.22c-9.027.085-18.7 5.826-24.344 19.405-11.143 26.803-31.93 59.156-58.563 93.47 10.57 8.694 19.85 18.92 27.5 30.31 35.1-26.57 68.882-46.81 98.125-56.75 44.6-15.16 12.02-69.72-35.343-35.343 26.91-27.842 11.107-51.27-7.376-51.093zm-341.22.03c-18.5.378-37.604 23.962-16.343 49.875C31.523 38.635-.802 85.48 37.095 102.813c28.085 12.844 62.54 35.66 99.062 64.343 8.125-12.5 18.207-23.61 29.78-32.937-26.782-35.743-48.44-69.835-61.78-98.47-4.515-9.69-12.22-13.66-20.03-13.5zm169.5 99.688c-67.104 0-121.31 54.21-121.31 121.312 0 44.676 24.04 83.613 59.905 104.656v56.406h18.718v-47.468c5.203 1.95 10.576 3.552 16.093 4.78v42.688h18.69v-40.03c2.614.167 5.247.25 7.905.25 2.637 0 5.25-.086 7.844-.25v40.03h18.686v-42.687c5.52-1.226 10.89-2.834 16.094-4.78v47.467h18.688V347.97c35.92-21.03 60-60.003 60-104.72 0-67.105-54.208-121.313-121.313-121.313zm-66.874 88.218c19.88 0 36 16.12 36 36s-16.12 36-36 36-36-16.12-36-36 16.12-36 36-36zm133.563 0c19.878 0 36 16.12 36 36s-16.122 36-36 36c-19.88 0-36-16.12-36-36s16.12-36 36-36zm-66.72 52.344l29.938 48.188h-59.874l29.938-48.188zm-107.28 70.563c-40.263 32.472-78.546 58.41-109.22 72.437-37.896 17.334-5.57 64.146 30.688 30.656-30.237 36.854 21.167 69.05 36.376 36.406 15.072-32.352 40.727-71.7 72.438-112.5-11.352-7.506-21.564-16.603-30.28-27zm213.156 1.718c-8.155 9.415-17.542 17.72-27.908 24.69 31.846 39.39 56.82 76.862 69.438 107.217 17.203 41.383 71.774 9.722 31.72-31.718 47.363 34.376 79.94-20.185 35.342-35.345-32.146-10.926-69.758-34.3-108.593-64.844z", // Lorc
  "gavel": "M129.75 24.47L21.625 211.655l55.78 32.188L185.532 56.656 129.75 24.47zm55.97 69.25l-75.626 130.874L326.47 349.47l75.592-130.876L185.72 93.72zm83.468.686l-11.22 19.438 84.97 49.03 11.25-19.468-85-49zM434.25 200.22L326.156 387.405l55.78 32.188 108.095-187.188-55.78-32.187zm-270.53 76.905l-11.282 19.53 84.968 49 11.25-19.5-84.937-49.03zm-3.095 45.844L61.312 494.81h67.157l82.28-142.968-50.125-28.875z", // Lorc
  "rocket": "M18.78 25.97c2.6 25.278 9.316 48.72 19.532 69.75l-21.218-6.564L73.53 146.72l-.843-1.782c16.737 17.29 36.797 31.38 59.438 41.593-13.546-18.845-21.597-41.677-22.03-69.28 27.78.35 50.396 8.56 69.25 22.063-.627-1.4-1.284-2.776-1.94-4.157l.72.625-34.438-86.655-2.53 33.844c-30.974-31.598-73.044-52.084-122.376-57zm236.814 31.593L217.22 160.875c-30.663 7.52-54.566 32.236-60.907 63.344l-.188-.22-106.563 39.563 74.313 74.312 93-8.03.375-.033 23.03-2.468-77.31-94.938 13.28-13.28 89.406 109.75 10.875 13.374-17.124 1.844-28.22 3.03c14.52 17.126 30.304 33.143 47.22 47.907 7.62-56.784 52.175-102.042 108.625-110.717-14.72-16.738-30.68-32.346-47.75-46.688l-2.78 26.125-1.844 17.125L321.28 270l-107.874-88.03 13.25-13.25 93.094 75.905 2.22-20.844 7.905-91.936-74.28-74.28zM401.53 301.625c-8.783.408-17.306 1.827-25.436 4.156l13.875 16.908c7.51-2.534 15.37-4.323 23.467-5.282-3.863-5.344-7.814-10.62-11.906-15.78zm-43.78 11.25c-7.323 3.61-14.204 7.994-20.5 13.063l15.75 17.28c5.92-4.876 12.318-9.16 19.125-12.812l-14.375-17.53zm68 22.438c-7.92.117-15.616 1.157-22.97 3.03l14.5 17.688c6.108-1.82 12.447-3.043 18.97-3.686-3.387-5.76-6.865-11.445-10.5-17.03zm-102.03 3.53c-6.713 7.584-12.4 16.116-16.845 25.344l17.313 14.125c4.28-7.958 9.44-15.37 15.375-22.093l-15.844-17.376zm60.467 6.282c-6.67 3.247-12.908 7.267-18.625 11.875l16.282 17.875c5.34-4.382 11.15-8.233 17.312-11.47l-14.97-18.28zm-32 24.938c-5.204 6.153-9.673 12.96-13.25 20.28l17.97 14.688c3.305-6.06 7.202-11.76 11.624-17l-16.342-17.967zm94.094.218v.22c-45.915 0-82.96 36.985-83.06 82.875 39.248 20.8 81.966 35.93 127.06 44.313-8.284-45.328-23.3-88.145-44-127.407zM299.94 382.626c-2.38 8.6-3.743 17.625-3.97 26.938 4.937 3.885 9.96 7.664 15.063 11.343.93-8.58 2.75-16.88 5.44-24.812l-16.533-13.47zm32.156 26.25c-2 7.785-3.073 15.96-3.094 24.375 5.28 3.43 10.632 6.727 16.063 9.938.72-6.992 2.156-13.776 4.218-20.282l-17.186-14.03z", // Lorc
  "hazard-sign": "M254.97 34.75c-30.48-.167-59.02 22.12-79.532 62.156-.075.146-.176.26-.25.406L43.063 326.783l-.22.343C18.5 365.413 13.377 401.515 28.47 428.03c15.08 26.498 48.627 40.126 93.5 37.908H387.063c44.887 2.227 78.445-11.404 93.53-37.907 15.09-26.51 9.956-62.595-14.375-100.874l-.22-.375L335.28 98.064c-.06-.12-.124-.225-.186-.344-20.948-40.263-49.626-62.803-80.125-62.97zm.06 18.844c13.576.13 26.453 6.93 38.126 18.343 11.606 11.347 22.554 27.453 33.406 48.344.063.122.125.224.188.345l115.22 201.563c.033.053.058.102.092.156l.125.22c12.92 20.274 21.395 38.06 25.282 53.967 3.91 16.01 3.063 30.648-3.845 42.408-6.908 11.76-19.222 19.533-34.78 23.906-15.444 4.34-34.508 5.656-57.408 4.5H137.625c-24.845 1.258-44.73-.32-60.405-5.125-15.78-4.84-27.68-13.45-33.72-25.69-6.04-12.237-5.862-26.797-1.5-42.436 4.333-15.535 12.815-32.608 24.875-51.53l.22-.377L183.562 120c.08-.157.17-.28.25-.438C194.51 98.644 205.32 82.6 216.875 71.376c11.642-11.307 24.58-17.913 38.156-17.78zm47.657 62.093l-28.53 224.032h-41.844L204.438 120.5c-1.404 2.556-2.81 5.205-4.22 7.97l-.093.218-.125.218-116.938 202.97-.093.187-.126.187C71.28 350.346 63.598 366.226 60 379.125c-3.598 12.9-3.108 22.322.25 29.125 3.358 6.803 9.925 12.28 22.47 16.125 12.542 3.845 30.67 5.547 54.405 4.313l.25-.032h234.313l.25.03c21.85 1.138 39.308-.28 51.875-3.81 12.566-3.533 19.822-8.827 23.687-15.407 3.865-6.58 4.978-15.545 1.813-28.5-3.166-12.958-10.732-29.374-23.094-48.72l-.126-.188-.125-.218-115.658-202.28-.093-.158-.064-.187c-2.5-4.828-4.99-9.326-7.47-13.532zM231.28 361.875h43.907v43.906H231.28v-43.905z", // Lorc
  "galleon": "M222.03 20.53v58.25L165.938 99l6.344 17.563 49.75-17.938v96.156l-87.155 33.845 6.75 17.406 80.406-31.218v141.97h-61.655l-1.438-7.594-4.687-25.063H95.812v-142.47l60.157-21.686-6.345-17.595-53.813 19.406V78.345H77.126v90.187l-52 18.75 6.344 17.564 45.655-16.47v135.75H26.437c5.565 54.4 27.327 108.08 66.782 143.595H375.56c9.543-51.545 39.83-95.146 73.688-136.44h-.063L494.594 299l-10.813-15.25-66.874 47.53H367.25V219.314l62.188-22.438-6.313-17.563-55.875 20.157v-67.032h-18.688v73.78l-49.937 18 6.313 17.563 43.625-15.75v121.595l-4.907 5.844-2.812 3.31H240.72V207.564l87.155-33.844-6.78-17.407-80.376 31.218V91.907l56.06-20.22-6.342-17.592-49.72 17.937v-51.5h-18.687z", // Lorc
  "submarine": "M315 144v21.75L292 160l-16 80H164c-49.154 16.385-81.254 27.1-102.578 34.846L52 256l-16-16v44.918C20.047 292.31 20 296.316 20 304c0 7.712.05 11.717 16 19.162V368l16-16 9.352-18.703c21.094 7.734 52.752 18.418 101.072 34.703H372c160-16 160-128 0-128h-16v-64l-23-5.75V144h-18zM148 263h256v18H148v-18z", // Delapouite
  "airplane": "M76.183 264.465l11.224 2.393-4.357 11.62a12.27 12.27 0 1 1-10.353-4.73zM378.67 321.61a21.078 21.078 0 1 0 11.968-5.17l-5.81-13.55h-14.257zm69.208-75.53c0 6.578-.221 12.934-.628 18.686h10.18v-33.93h-9.97c.232 4.845.406 9.981.406 15.28zm-22.903 40.438h-80.7c-115.408 0-213.503-28.504-286.336-42.459C26.415 238.018 21 226.526 21 213.151c0-17.894 9.633-59.656 39.24-59.656 24.576 0 53.08 61.364 62.422 61.364 3.986 0 170.033-9.144 170.033-9.144 0 8.354 13.851 12.526 27.714 12.526 13.862 0 27.887-4.218 27.887-12.62v-22.519s23.868 12.782 30.55 22.566h46.107c8.796 0 8.796 80.886.011 80.886zM408.8 247.802c0-3.998-3.66-7.251-8.134-7.251H248.168c-4.508 0-8.134 3.242-8.134 7.25 0 4.01 3.66 7.251 8.134 7.251h152.453c4.508.035 8.168-3.218 8.168-7.215zm73.984-57.007a8.134 8.134 0 0 0-8.134 8.134v94.283a8.175 8.175 0 0 0 16.349 0v-94.214a8.134 8.134 0 0 0-8.227-8.169z", // Skoll
  "anchor": "M90.53 23c-18.345 0-36.688 7.002-50.686 21-27.996 27.996-27.994 73.38 0 101.375 21.776 21.776 54.08 26.603 80.53 14.5l53.69 53.688c-21.425 19.696-44 38.257-67.44 55.937l30.126 30.125c18.734-22.545 37.953-44.474 57.844-65.53l169.594 169.593c-51.845 40.444-120.866 53.838-192.813 42.562L173 424.906 72.47 404.47l95.405 88.405 1.97-26c86.593 36.97 177.603 34.61 241.343-11.75l63.062 21.313-21.47-63.594c44.61-63.62 46.408-153.412 9.908-238.875l26.03-1.97-88.406-95.375 20.438 100.53 21.344-1.624c11.278 71.983-2.168 141.017-42.656 192.876l-169.782-169.75c21.075-20.34 42.93-39.665 65.78-57.72l-30.123-30.124c-17.015 24.154-35.673 46.66-55.688 67.813l-53.97-53.97C167.834 98.183 163.032 65.814 141.22 44c-14-13.998-32.343-21-50.69-21zm0 27.03c11.434.002 22.872 4.34 31.595 13.064 17.447 17.447 17.446 45.742 0 63.187-17.446 17.447-45.71 17.447-63.156 0-17.447-17.444-17.448-45.74 0-63.186C67.69 54.37 79.097 50.03 90.53 50.03z", // Lorc
};

const PATHS = {};
const glyph = (name) => (PATHS[name] ||= new Path2D(GLYPHS[name]));

// Event icon -> glyph. Icons without a glyph get a plain plate.
const EVENT_GLYPHS = {
  sword: "crossed-swords",
  explosion: "explosion-rays",
  scroll: "scroll-unfurled",
  fist: "fist",
  knife: "plain-dagger",
  skull: "skull-crossed-bones",
  gavel: "gavel",
  rocket: "rocket",
  danger: "hazard-sign",
};

export function canvasImage(width, height, draw) {
  const c = document.createElement("canvas");
  c.width = width;
  c.height = height;
  // Read back on the CPU: a GPU canvas costs a slow readback per icon.
  const ctx = c.getContext("2d", { willReadFrequently: true });
  draw(ctx, width, height);
  return ctx.getImageData(0, 0, width, height);
}

// A glyph filling a box of size s at (x, y), optionally mirrored.
function drawGlyph(ctx, name, x, y, s, fill, flip = false) {
  ctx.save();
  ctx.translate(flip ? x + s : x, y);
  ctx.scale(((flip ? -1 : 1) * s) / 512, s / 512);
  ctx.fillStyle = fill;
  ctx.fill(glyph(name));
  ctx.restore();
}

// A counter plate: flat color, a dark frame and a bevel (light top and
// left edge, dark bottom and right), like a cardboard wargame counter.
function plate(ctx, x, y, w, h, fill) {
  ctx.fillStyle = fill;
  ctx.fillRect(x, y, w, h);
  ctx.lineWidth = 2;
  ctx.strokeStyle = "rgba(255,255,255,0.45)";
  ctx.beginPath();
  ctx.moveTo(x + 2.5, y + h - 2.5);
  ctx.lineTo(x + 2.5, y + 2.5);
  ctx.lineTo(x + w - 2.5, y + 2.5);
  ctx.stroke();
  ctx.strokeStyle = "rgba(0,0,0,0.35)";
  ctx.beginPath();
  ctx.moveTo(x + w - 2.5, y + 2.5);
  ctx.lineTo(x + w - 2.5, y + h - 2.5);
  ctx.lineTo(x + 2.5, y + h - 2.5);
  ctx.stroke();
  ctx.lineWidth = 3;
  ctx.strokeStyle = INK;
  ctx.strokeRect(x, y, w, h);
}

// ---------------------------------------------------------------------------
// Events
// ---------------------------------------------------------------------------

// state: "now" (under way on the date), "past" or "next". A battle under
// way can carry its sides' colors as a bar under the plate.
export function eventMarker(icon, color, state, sideColors = []) {
  return canvasImage(56, 76, (ctx) => {
    const name = EVENT_GLYPHS[icon];
    if (state === "now") {
      plate(ctx, 8, 10, 40, 40, color);
      if (name) drawGlyph(ctx, name, 14, 16, 28, INK);
      if (sideColors.length > 1) {
        const w = 40 / sideColors.length;
        sideColors.forEach((c, i) => {
          ctx.fillStyle = c;
          ctx.fillRect(8 + i * w, 54, w, 8);
        });
        ctx.lineWidth = 2;
        ctx.strokeStyle = INK;
        ctx.strokeRect(8, 54, 40, 8);
        for (let i = 1; i < sideColors.length; i++) {
          ctx.beginPath();
          ctx.moveTo(8 + i * w, 54);
          ctx.lineTo(8 + i * w, 62);
          ctx.stroke();
        }
      }
      return;
    }
    // Over: a dark plate with the glyph in a faded color. To come: an
    // outline only.
    const past = state === "past";
    ctx.fillStyle = past ? PAST_FILL : "rgba(21,27,39,0.6)";
    ctx.fillRect(10, 12, 36, 36);
    ctx.lineWidth = 2;
    ctx.strokeStyle = color;
    ctx.globalAlpha = past ? 0.6 : 0.8;
    if (!past) ctx.setLineDash([5, 3]);
    ctx.strokeRect(10, 12, 36, 36);
    ctx.setLineDash([]);
    ctx.globalAlpha = past ? 0.75 : 0.55;
    if (name) drawGlyph(ctx, name, 15, 17, 26, color);
  });
}

// The ring that pulses around battles under way: frame k of n, a square
// that grows and fades.
export function pulseFrame(k, n) {
  return canvasImage(112, 112, (ctx) => {
    const t = k / n;
    const half = 22 + t * 30;
    ctx.globalAlpha = 0.9 * (1 - t);
    ctx.lineWidth = 3;
    ctx.strokeStyle = "#ffe08a";
    ctx.strokeRect(56 - half, 56 - half, half * 2, half * 2);
  });
}

// ---------------------------------------------------------------------------
// Units
// ---------------------------------------------------------------------------

// NATO size marks: X per level from brigade up, I for regiments and
// battalions.
const ECHELONS = {
  army_group: "XXXXX",
  army: "XXXX",
  corps: "XXX",
  division: "XX",
  brigade: "X",
  regiment: "III",
  battalion: "II",
};

function echelonMarks(ctx, kind, cx, baseline) {
  const marks = ECHELONS[kind];
  if (!marks) return;
  const w = marks[0] === "X" ? 7 : 4;
  const gap = 2;
  const total = marks.length * w + (marks.length - 1) * gap;
  let x = cx - total / 2;
  ctx.lineCap = "square";
  for (const outline of [true, false]) {
    ctx.strokeStyle = outline ? INK : LIGHT;
    ctx.lineWidth = outline ? 4.5 : 2;
    x = cx - total / 2;
    ctx.beginPath();
    for (const m of marks) {
      if (m === "X") {
        ctx.moveTo(x, baseline - 9);
        ctx.lineTo(x + w, baseline);
        ctx.moveTo(x + w, baseline - 9);
        ctx.lineTo(x, baseline);
      } else {
        ctx.moveTo(x + w / 2, baseline - 9);
        ctx.lineTo(x + w / 2, baseline);
      }
      x += w + gap;
    }
    ctx.stroke();
  }
}

// Battlements on top of the frame for a garrison or fortress.
function battlements(ctx, x, y, w) {
  ctx.fillStyle = LIGHT;
  ctx.strokeStyle = INK;
  ctx.lineWidth = 2;
  for (let i = 0; i < 4; i++) {
    const bx = x + 4 + i * ((w - 14) / 3);
    ctx.fillRect(bx, y - 8, 6, 8);
    ctx.strokeRect(bx, y - 8, 6, 8);
  }
}

// Land unit: a NATO frame in the side's color with the symbol of its arm
// (infantry X, cavalry slash, armor track, and so on) and its size above.
export function landCounter(unitType, kind, color) {
  return canvasImage(64, 60, (ctx) => {
    const x = 6;
    const y = 20;
    const w = 52;
    const h = 34;
    plate(ctx, x, y, w, h, color);
    ctx.strokeStyle = INK;
    ctx.fillStyle = INK;
    ctx.lineWidth = 2.5;
    const cx = x + w / 2;
    const cy = y + h / 2;
    const cross = () => {
      ctx.beginPath();
      ctx.moveTo(x + 2, y + 2);
      ctx.lineTo(x + w - 2, y + h - 2);
      ctx.moveTo(x + w - 2, y + 2);
      ctx.lineTo(x + 2, y + h - 2);
      ctx.stroke();
    };
    const track = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy, 15, 8, 0, 0, Math.PI * 2);
      ctx.stroke();
    };
    switch (unitType) {
      case "cavalry":
        ctx.beginPath();
        ctx.moveTo(x + 2, y + h - 2);
        ctx.lineTo(x + w - 2, y + 2);
        ctx.stroke();
        break;
      case "armor":
        track();
        break;
      case "mechanized":
        cross();
        track();
        break;
      case "artillery":
        ctx.beginPath();
        ctx.arc(cx, cy, 5, 0, Math.PI * 2);
        ctx.fill();
        break;
      case "airborne":
        cross();
        ctx.beginPath();
        ctx.arc(cx - 6, y + h - 4, 6, Math.PI, 0);
        ctx.arc(cx + 6, y + h - 4, 6, Math.PI, 0);
        ctx.stroke();
        break;
      case "marines":
        drawGlyph(ctx, "anchor", cx - 13, cy - 13, 26, INK);
        break;
      case "mountain":
        cross();
        ctx.beginPath();
        ctx.moveTo(cx - 8, y + h - 1.5);
        ctx.lineTo(cx, y + h - 11);
        ctx.lineTo(cx + 8, y + h - 1.5);
        ctx.closePath();
        ctx.fill();
        break;
      default:
        cross();
    }
    if (kind === "garrison") battlements(ctx, x, y, w);
    else echelonMarks(ctx, kind, cx, y - 5);
  });
}

// Naval and air units: a silhouette on a plate in the side's color,
// facing its way of travel. Without a recorded type a ship's silhouette
// follows the era: sail until the 1860s, ironclads until the dreadnought
// (1906).
export function navalShape(unitType, year) {
  if (unitType === "carrier" || unitType === "submarine" || unitType === "ironclad") return unitType;
  if (unitType === "sailing") return "galleon";
  if (unitType) return "battleship";
  if (year < 1862) return "galleon";
  if (year < 1906) return "ironclad";
  return "battleship";
}

// Ships drawn here face right, in a 56x28 box: hull to the waterline at
// y 26, superstructure above.
function poly(ctx, pts) {
  ctx.beginPath();
  pts.forEach(([px, py], i) => (i ? ctx.lineTo(px, py) : ctx.moveTo(px, py)));
  ctx.closePath();
  ctx.fill();
}

function lines(ctx, segs) {
  ctx.beginPath();
  segs.forEach(([x1, y1, x2, y2]) => {
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
  });
  ctx.stroke();
}

const SHIPS = {
  battleship(ctx) {
    poly(ctx, [[1, 18], [55, 16], [50, 26], [6, 26]]);
    ctx.fillRect(19, 12, 15, 6);
    ctx.fillRect(30, 6, 5, 6);
    ctx.fillRect(22, 7, 3.5, 5);
    ctx.fillRect(26.5, 8, 3, 4);
    ctx.fillRect(38, 13, 7, 4);
    ctx.fillRect(9, 13, 7, 4);
    lines(ctx, [[45, 14, 51, 13], [9, 14, 3, 13], [32.5, 0, 32.5, 6]]);
  },
  carrier(ctx) {
    ctx.fillRect(0, 14, 56, 3);
    poly(ctx, [[4, 17], [54, 17], [49, 26], [9, 26]]);
    ctx.fillRect(36, 7, 6, 7);
    lines(ctx, [[39, 1, 39, 7], [36, 3, 42, 3]]);
  },
  ironclad(ctx) {
    poly(ctx, [[2, 20], [54, 19], [51, 26], [5, 26]]);
    ctx.fillRect(17, 14, 20, 6);
    ctx.fillRect(25, 6, 5, 8);
    lines(ctx, [[12, 2, 12, 20], [44, 2, 44, 19], [8, 6, 16, 6], [40, 6, 48, 6]]);
  },
};

// Glyph silhouettes and which way they face.
const GLYPH_SHAPES = { galleon: "right", submarine: "left", airplane: "right" };

export function craftCounter(shape, color, flip) {
  return canvasImage(72, 48, (ctx) => {
    plate(ctx, 4, 6, 64, 36, color);
    if (GLYPH_SHAPES[shape]) {
      const mirror = flip !== (GLYPH_SHAPES[shape] === "left");
      ctx.save();
      ctx.beginPath();
      ctx.rect(6, 8, 60, 32);
      ctx.clip();
      drawGlyph(ctx, shape, 13, -2, 46, INK, mirror);
      ctx.restore();
      return;
    }
    ctx.save();
    ctx.translate(flip ? 64 : 8, 10);
    ctx.scale(flip ? -1 : 1, 1);
    ctx.fillStyle = INK;
    ctx.strokeStyle = INK;
    ctx.lineWidth = 1.5;
    SHIPS[shape](ctx);
    ctx.restore();
  });
}
